import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Collection } from './components/Collection';
import { HowItWorks } from './components/HowItWorks';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-full w-full bg-cream font-body text-ink" data-id="element-0" data-mp="31ayry6a7fw1e">
      <CountdownBar data-id="element-1" data-mp="2wk09p15nonvi" />
      <Hero data-id="element-2" data-mp="2wjgrrkg09zhh" />
      <main data-id="element-3" data-mp="2wjql9i09eorx">
        <Problems data-id="element-4" data-mp="2wj8dbo48im46" />
        <Collection data-id="element-5" data-mp="2wip7v6vrtq71" />
        <HowItWorks data-id="element-6" data-mp="2wi5m1f302hnq" />
        <Bonuses data-id="element-7" data-mp="28tw6guwdqq51" />
        <OfferStack id="offer" title="Here's Everything Included Today" priceLabel="🔥 Your price today" savingsLabel="🎉 Save $58 today" ctaLabel="Yes! Give Me the Complete Kit for $27 →" showMockup data-id="element-8" data-mp="28te198rqp1kz" />
        <Testimonials data-id="element-9" data-mp="3mlawr57iwbsx" />
        <OfferStack id="checkout" title="Everything Included With Your Order" priceLabel="🔥 Get everything today for" savingsLabel="🎉 That's $58 in savings" ctaLabel="I want the complete kit →" tone="dark" data-id="element-10" data-mp="3mkrchhuehbbq" />
        <Faq data-id="element-11" data-mp="2zld2jatxbhc2" />
      </main>
      <Footer data-id="element-12" data-mp="2zm4zaoz9bl3x" />
    </div>;
}